__turbopack_context__.v({
  "container": "home-module-scss-module__3S3Ydq__container",
  "content": "home-module-scss-module__3S3Ydq__content",
  "footer": "home-module-scss-module__3S3Ydq__footer",
  "home-slogan": "home-module-scss-module__3S3Ydq__home-slogan",
  "homeBackdrop": "home-module-scss-module__3S3Ydq__homeBackdrop",
  "homeImage": "home-module-scss-module__3S3Ydq__homeImage",
  "homeItemCardPopup": "home-module-scss-module__3S3Ydq__homeItemCardPopup",
  "homeItemStretched": "home-module-scss-module__3S3Ydq__homeItemStretched",
  "homeItemTrigger": "home-module-scss-module__3S3Ydq__homeItemTrigger",
  "homeItemWrapper": "home-module-scss-module__3S3Ydq__homeItemWrapper",
  "homePopupScaleAppear": "home-module-scss-module__3S3Ydq__homePopupScaleAppear",
  "homePopupScaleAppearActive": "home-module-scss-module__3S3Ydq__homePopupScaleAppearActive",
  "homePopupScaleEnter": "home-module-scss-module__3S3Ydq__homePopupScaleEnter",
  "homePopupScaleEnterActive": "home-module-scss-module__3S3Ydq__homePopupScaleEnterActive",
  "homePopupScaleExit": "home-module-scss-module__3S3Ydq__homePopupScaleExit",
  "homePopupScaleExitActive": "home-module-scss-module__3S3Ydq__homePopupScaleExitActive",
  "homeSloganFadeEnter": "home-module-scss-module__3S3Ydq__homeSloganFadeEnter",
  "homeSloganFadeEnterActive": "home-module-scss-module__3S3Ydq__homeSloganFadeEnterActive",
  "homeSloganFadeExit": "home-module-scss-module__3S3Ydq__homeSloganFadeExit",
  "homeSloganFadeExitActive": "home-module-scss-module__3S3Ydq__homeSloganFadeExitActive",
  "homeToBuysSlideEnter": "home-module-scss-module__3S3Ydq__homeToBuysSlideEnter",
  "homeToBuysSlideEnterActive": "home-module-scss-module__3S3Ydq__homeToBuysSlideEnterActive",
  "homeToBuysSlideExit": "home-module-scss-module__3S3Ydq__homeToBuysSlideExit",
  "homeToBuysSlideExitActive": "home-module-scss-module__3S3Ydq__homeToBuysSlideExitActive",
  "homeWorld": "home-module-scss-module__3S3Ydq__homeWorld",
  "homeWrapper": "home-module-scss-module__3S3Ydq__homeWrapper",
  "slogan": "home-module-scss-module__3S3Ydq__slogan",
  "sloganFadeActive": "home-module-scss-module__3S3Ydq__sloganFadeActive",
  "sloganFaded": "home-module-scss-module__3S3Ydq__sloganFaded",
  "sloganMerchFadeOut": "home-module-scss-module__3S3Ydq__sloganMerchFadeOut",
});
